import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-alert-border',
  props: {
    modelValue: { type: Boolean },
    isAutoClose: { type: Boolean, default: true }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: emits }) {

const props = __props as { modelValue: boolean, isAutoClose: boolean }




// 3秒后自动关闭
watch(
  () => props.modelValue,
  (val) => {
    if (val && props.isAutoClose) {
      setTimeout(() => {
        emits('update:modelValue', false)
      }, 3000)
    }
  }
)

return { __sfc: true,props, emits }
}

})